var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8999 0.902954L8.0999 5.70295V21.0971L12.8999 16.2971V0.902954Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.94843 2.95148C2.60523 2.60828 2.08909 2.50562 1.64068 2.69136C1.19227 2.87709 0.899902 3.31466 0.899902 3.80001V15.8C0.899902 16.1183 1.02633 16.4235 1.25137 16.6485L5.6999 21.0971V5.70295L2.94843 2.95148Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7484 5.35148L15.2999 0.902954V16.2971L18.0514 19.0485C18.3946 19.3917 18.9107 19.4944 19.3591 19.3087C19.8075 19.1229 20.0999 18.6854 20.0999 18.2V6.20001C20.0999 5.88175 19.9735 5.57653 19.7484 5.35148Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.a981849ffaf3732d07585af7b0e862a9.svg";
export { ForwardRef as ReactComponent };